
function backToTop() {

    var b2t = document.getElementById('b2t');

    if (b2t) {
        var footer = document.getElementById('colophon');

        b2t.addEventListener('click', function (e) {
            e.preventDefault();
            window.scrollTo({top: 0, behavior: 'smooth'});
        });

        document.addEventListener('scroll', function(e) {
            e.preventDefault();
            var documentHeight = document.body.scrollHeight;
            var currentScroll = window.scrollY + window.innerHeight;
            var modifier = footer.offsetHeight;

            if (currentScroll + modifier > documentHeight) {
                b2t.classList.add('show');
            } else {
                b2t.classList.remove('show');
            }
        })
    }
}

export default function init()
{
    backToTop();
}
